import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const HomeAdmin = () => {

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4, padding: 4 }}>
      <Card sx={{ maxWidth: '600px', margin: '0 auto', padding: 2 }}>
        <CardContent sx={{minWidth: '30em'}}>
          <Typography sx={{ textAlign:'center', paddingBottom:'1em'}} variant="h6" gutterBottom>
            Import CSV
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Link to="/admin/csv/players">
              <Button variant="contained" fullWidth>Joueurs CSV</Button>
            </Link>
            <Link to="/admin/csv/teams">
              <Button variant="contained" fullWidth>Equipes CSV</Button>
            </Link>
            <Link to="/admin/csv/matches">
              <Button variant="contained" fullWidth>Matchs CSV</Button>
            </Link>
            <Link to="/admin/csv/calendar">
              <Button variant="contained" fullWidth>Calendrier CSV</Button>
            </Link>
            <Link to="/admin/csv/multisport/calendar">
              <Button variant="contained" fullWidth>Calendrier multisport</Button>
            </Link>
            <Link to="/admin/csv/multisport/actors">
              <Button variant="contained" fullWidth>Acteurs multisport</Button>
            </Link>
          </Box>
        </CardContent>
      </Card>

      <Card sx={{maxWidth: '600px', margin: '0 auto', padding: 2 }}>
        <CardContent sx={{minWidth: '30em'}}>
          <Typography sx={{ textAlign:'center', paddingBottom:'1em'}} variant="h6" gutterBottom>
            Paramétrage APIs
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Link to="/admin/manager/api_data">
              <Button variant="contained" fullWidth>Gestion des clefs</Button>
            </Link>
          </Box>
        </CardContent>
      </Card>

      
      <Card sx={{maxWidth: '600px', margin: '0 auto', padding: 2 }}>
        <CardContent sx={{minWidth: '30em'}}>
          <Typography sx={{ textAlign:'center', paddingBottom:'1em'}} variant="h6" gutterBottom>
            Monitoring
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Link to="/admin/datasync/apis/webhook">
              <Button variant="contained" fullWidth>Logs webhook</Button>
            </Link>
            <Link to="/admin/datasync/jobs">
              <Button variant="contained" fullWidth>Files d'attentes</Button>
            </Link>
            <Link to="/admin/datasync/jobs/fix">
              <Button variant="contained" fullWidth>Bull/Redis manager</Button>
            </Link>
          </Box>
        </CardContent>
      </Card>

      <Card sx={{maxWidth: '600px', margin: '0 auto', padding: 2 }}>
        <CardContent sx={{minWidth: '30em'}}>
          <Typography sx={{ textAlign:'center', paddingBottom:'1em'}} variant="h6" gutterBottom>
            Gestion du cache (V2)
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Link to="/admin/manager/cacheconfigs">
              <Button variant="contained" fullWidth>Gérer les caches</Button>
            </Link>
          </Box>
        </CardContent>
      </Card>

      <Card sx={{maxWidth: '600px', margin: '0 auto', padding: 2 }}>
        <CardContent sx={{minWidth: '30em'}}>
          <Typography sx={{ textAlign:'center', paddingBottom:'1em'}} variant="h6" gutterBottom>
            Synchronisation des données (V2)
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Link to="/admin/datasync/webhook/send">
              <Button variant="contained" fullWidth>Webhook (V2)</Button>
            </Link>
          </Box>
        </CardContent>
      </Card>

    </Box>
  );
}

export default HomeAdmin